/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../model/shared/device';
import '../model/device_profile';
import '../model/shared/device_profile';
import './status';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "message": {
                    "nested": {
                      "CreateDeviceProfileV2Request": {
                        "fields": {
                          "device": {
                            "type": ".squareup.devicesettings.profiles.v2.model.shared.Device",
                            "id": 1,
                            "rule": "optional"
                          },
                          "profile": {
                            "type": ".squareup.devicesettings.profiles.v2.model.DeviceProfileV2",
                            "id": 2,
                            "rule": "optional"
                          },
                          "deviceProfile": {
                            "type": ".squareup.devicesettings.profiles.v2.model.shared.DeviceProfile",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "CreateDeviceProfileV2Response": {
                        "fields": {
                          "status": {
                            "type": ".squareup.devicesettings.profiles.v2.message.Status",
                            "id": 1,
                            "rule": "optional"
                          },
                          "profile": {
                            "type": ".squareup.devicesettings.profiles.v2.model.DeviceProfileV2",
                            "id": 2,
                            "rule": "optional"
                          },
                          "deviceProfile": {
                            "type": ".squareup.devicesettings.profiles.v2.model.shared.DeviceProfile",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.message?.nested?.CreateDeviceProfileV2Request && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.message?.nested?.CreateDeviceProfileV2Response) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE CreateDeviceProfileV2Request @ squareup/devicesettings/profiles/v2/message/create_device_profile.proto at 14:1
 */
export const CreateDeviceProfileV2Request = $root.lookupType('squareup.devicesettings.profiles.v2.message.CreateDeviceProfileV2Request');
fixType(CreateDeviceProfileV2Request, {
  deviceProfile: {
    required: true
  }
});
Builder.createAndAttachToType(CreateDeviceProfileV2Request);
/**
 * SOURCE CreateDeviceProfileV2Response @ squareup/devicesettings/profiles/v2/message/create_device_profile.proto at 20:1
 */
export const CreateDeviceProfileV2Response = $root.lookupType('squareup.devicesettings.profiles.v2.message.CreateDeviceProfileV2Response');
fixType(CreateDeviceProfileV2Response);
Builder.createAndAttachToType(CreateDeviceProfileV2Response);